import {Component} from '@angular/core';

@Component({
    selector: 'app-walkthrough-bulk-upload',
    templateUrl: './walkthrough-bulk-upload.component.html',
    styleUrls: ['../product-walkthrough.component.scss'],
    standalone: false
})
export class WalkthroughBulkUploadComponent
{
}
